import { createContext, useContext } from 'react';
export const PortalContext = createContext({ isPortal: false });
export const HeaderNavigationDataContext = createContext({});
export const HeaderDataContext = createContext({
    customerData: null,
    ppDashboardData: null,
    ppDashboardResponseState: null,
    dbsDepositsAccess: null,
    productAccess: [],
    transactionAccountData: null,
    refetchTransactionAccountData: () => { },
    piaProductInstances: null,
    transactionAccountError: false,
    isHeaderDataLoading: false,
    hasDWMProduct: false,
    hasMigratedRobo: false,
    pomProducts: null,
    cobranding: undefined,
    productsTypes: null,
    customerDataFetchState: {
        isLoading: false,
        error: undefined,
        mutate: undefined,
        isValidating: false,
    },
});
export const useHeaderDataContext = () => {
    const context = useContext(HeaderDataContext);
    if (!context) {
        throw new Error('useHeaderDataContext must be used within a HeaderDataContext');
    }
    return context;
};
//# sourceMappingURL=headerData.js.map